import {
    DISCONNECT_ASSET_REQUEST,
    DISCONNECT_ASSET
} from './constants';
import { getApiActionCreator } from 'helpers/actionHelper';
export const getAssetDisconnectAction = getApiActionCreator(DISCONNECT_ASSET);

export const disconnectAssetRequest = (assetId, gatewayId, onResetAssetInfo) => ({
    type: DISCONNECT_ASSET_REQUEST,
    assetId,
    gatewayId,
    onResetAssetInfo
});
